import {EvkHttpService, EvkOption, EvkResponseType} from "@evomatik/evk-common";
import {Injectable} from "@angular/core";
import {map} from "rxjs/operators";
import {Observable} from "rxjs";

@Injectable({providedIn: 'root'})
export class TareaDocumentoConsultasService {

    constructor(
        public http: EvkHttpService
    ) {
    }

    public getExpedientesByTipo = (idTipo: string): Observable<EvkOption[]> => {
        return this.http.get<EvkResponseType<EvkOption[]>>(`/seaged-expedientes-service/expediente/by-config/${idTipo}/options`)
            .pipe(map(resoponse => resoponse.data));
    }

    public getTipoDiligencias() {
        return this.http.get<EvkResponseType<Array<any>>>(`/seaged-diligencias-service/diligencia-config/list`).pipe(
            map(response => response.data)
        );
    }
    public getDiligenciasRespuestas(idDiligenciaConfig:string) {
        return this.http.get<EvkResponseType<Array<any>>>(`/seaged-diligencias-service/diligencia-config/${idDiligenciaConfig}/diligencias-respuestas/options`).pipe(
            map(response => response.data)
        );
    }
}
